// extracted by mini-css-extract-plugin
export default {"container":"lazyYandexHotelMap-module__container__2jivN","mobileContainer":"lazyYandexHotelMap-module__mobileContainer__5kfdy"};